import * as React from 'react'
import styled from 'styled-components'

const urnIcon = require('src/assets/configurator/urn_icon.png')
const coffinIcon = require('src/assets/configurator/coffin_icon.png')

// The callback function is required as this is a fake loader
// on the one hand it depends on the "loading" request being
// successful but also on when 100% is reached. As these times
// can differ there is a cross dependency
interface Props {
  loadingFinishedCallback: () => void
  isBurial?: boolean
  uuidReady?: boolean
}

interface State {
  percentage: number
  loadingStep: number
}

export default class QuickLoading extends React.Component<Props, State> {
  maxAdded = 5
  timeBetweenIncrease = 225

  constructor(props) {
    super(props)
    this.state = { percentage: 0, loadingStep: 0 }
  }

  componentDidMount() {
    this.increase()
  }

  increase = () => {
    const { uuidReady, loadingFinishedCallback } = this.props
    const { percentage } = this.state
    let newPercentage = Math.floor(Math.random() * this.maxAdded) + percentage
    let loadingStep = 0

    if (newPercentage >= 33) {
      ++loadingStep
    }
    if (newPercentage >= 60) {
      ++loadingStep
    }

    if (newPercentage < 100) {
      setTimeout(this.increase, this.timeBetweenIncrease)
    } else if (newPercentage >= 100 && uuidReady) {
      newPercentage = 100
      ++loadingStep
      loadingFinishedCallback()
    } else {
      newPercentage = percentage
    }

    this.setState({ percentage: newPercentage, loadingStep })
  }

  getIcon = (forStep) => {
    const { loadingStep } = this.state
    if (forStep < loadingStep) {
      return 'fas fa-check'
    } else {
      return 'fas fa-ellipsis-h'
    }
  }

  render() {
    const { isBurial } = this.props
    const { percentage } = this.state

    return (
      <Container percentage={percentage} burial={isBurial}>
        <div className='loader-icon'>
          <div className='loader-overlay'></div>
        </div>
        <p>{percentage}%</p>
        <LoadingChecklist>
          <li className='checklistitem'>
            <i className={this.getIcon(0)} />
            <p>Optimaler Preis berechnet</p>
          </li>
          <li className='checklistitem'>
            <i className={this.getIcon(1)} />
            <p>Externe Gebühren ermittelt</p>
          </li>
          <li className='checklistitem'>
            <i className={this.getIcon(2)} />
            <p>Umfassendes Angebot erstellt</p>
          </li>
        </LoadingChecklist>
      </Container>
    )
  }
}

const Container = styled.div`
  .loader-icon {
    position: relative;
    height: 150px;
    width: 60px;
    margin: auto;
    background-image: url(${(props) => (props.burial ? coffinIcon : urnIcon)});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  .loader-icon .loader-overlay {
    position: absolute;
    top: -${(props) => 150 * (props.percentage / 100)}px;
    left: 0;
    content: '';
    height: 150px;
    width: 100%;
    background-color: #dbe6e9;
    opacity: 0.8;
  }

  p {
    text-align: center;
  }
`

const LoadingChecklist = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 350px;
  margin: auto;

  .checklistitem {
    margin-bottom: 7.5px;
  }

  .checklistitem p {
    display: inline;
    margin-left: 15px;
  }
`



// WEBPACK FOOTER //
// ./src/components/molecules/wizard/QuickLoading.tsx